import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {isString} from 'lodash';

// account-conversion
import styles from '../stylesheets/base-step.module.scss';
import {scrollFromFooterOnFocus} from 'shared/scroll-on-focus';

export default class BaseStep extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    stepHeader: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    ]).isRequired,
    subHeader: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    ]),
    disclaimer: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    ]),
    className: PropTypes.string,
    pageTitle: PropTypes.string,
  };

  componentDidMount() {
    const {pageTitle, stepHeader} = this.props;

    let title;

    if (pageTitle) {
      title = pageTitle;
    } else if (isString(stepHeader)) {
      title = stepHeader;
    } else {
      title = 'Tell us about yourself - Raise Me';
    }

    document.title = title;

    window.scrollTo(0, 0);
    scrollFromFooterOnFocus(150, 'input, select');
  }

  render() {
    const {children, stepHeader, subHeader, disclaimer, className} = this.props;

    return (
      <div
        className={classnames(styles.container, 'shared-base-step', className)}
        data-testid="step-header-container"
      >
        <div className={styles.headerWrapper}>
          <h1 id="stepHeader" className={styles.stepHeader}>
            {stepHeader}
          </h1>
          {subHeader && <h2 className={styles.subHeader}>{subHeader}</h2>}
          {disclaimer && <p className={styles.disclaimer}>{disclaimer}</p>}
        </div>
        {children && <div className={styles.formContainer}>{children}</div>}
      </div>
    );
  }
}
